import { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Button, Chip, Drawer, Link } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Logo from './Logoblack';

function MainSidebar(props) {
  const { onMobileClose, openMobile } = props;
  const location = useLocation();
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  return (
    <Drawer
      anchor="left"
      onClose={onMobileClose}
      open={!lgUp && openMobile}
      variant="temporary"
      PaperProps={{ sx: { backgroundColor: 'background.default', width: 256 } }}
    >
      <Box sx={{ alignItems: 'flex-start', display: 'flex', flexDirection: 'column', height: '100%', p: 2 }}>
        <RouterLink to="/">
          <Logo />
        </RouterLink>
        <Box sx={{ display: 'flex', pb: 2, pt: 3 }}>
          <Link color="textSecondary" underline="none" variant="body1">
            Clientes
          </Link>
          <Chip color="primary" label="Nuevo" size="small" sx={{ maxHeight: 20, ml: 1, mr: 2 }} />
        </Box>
        <Link color="textSecondary" underline="none" variant="body1">
          Ayuda
        </Link>
        <Button color="primary" component={RouterLink} to="/panel" variant="contained" size="small" sx={{ mt: 4 }}>
          Ingresar
        </Button>
      </Box>
    </Drawer>
  );
}

MainSidebar.propTypes = { onMobileClose: PropTypes.func, openMobile: PropTypes.bool };

export default MainSidebar;
